import HeroSection from "@/components/home/HeroSection";
import BrandMarquee from "@/components/home/BrandMarquee";
import BrandsShowcase from "@/components/home/BrandsShowcase";
import ManifestoSection from "@/components/home/ManifestoSection";
import ContactSection from "@/components/contact/ContactSection";

export default function Home() {
  return (
    <main>
      <HeroSection />
      <BrandMarquee />
      <BrandsShowcase />
      <ManifestoSection />
      <ContactSection />
    </main>
  );
}
